/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Mod_Rental_DescInputs */

const es_faq_mod_rental_desc = /** @type {(inputs: Faq_Mod_Rental_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrendamiento náutico regulado. Alquila tu barco hasta 3 meses al año. Requiere cambio de uso y despacho temporal.`)
};

const gl_faq_mod_rental_desc = /** @type {(inputs: Faq_Mod_Rental_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrendamento náutico regulado. Aluga o teu barco ata 3 meses ao ano. Require cambio de uso e despacho temporal.`)
};

const en_faq_mod_rental_desc = /** @type {(inputs: Faq_Mod_Rental_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulated boat rental. Rent out your boat for up to 3 months a year. Requires change of use and temporary dispatch.`)
};

/**
* | output |
* | --- |
* | "Regulated boat rental. Rent out your boat for up to 3 months a year. Requires change of use and temporary dispatch." |
*
* @param {Faq_Mod_Rental_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_mod_rental_desc = /** @type {((inputs?: Faq_Mod_Rental_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Mod_Rental_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_mod_rental_desc(inputs)
	if (locale === "en") return en_faq_mod_rental_desc(inputs)
	return es_faq_mod_rental_desc(inputs)
});